import React, { useEffect } from 'react';
import Alert from 'fe-design-base/molecules/Alert/Alert';
import { useFormikContext } from 'formik';

import { I18N_PATH } from 'features/team/components/TaxEntryForm/constants';
import { BANNER_VERSION } from 'features/teamView/tracking';

import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

const AddressConfirmAlert = () => {
  const { values } = useFormikContext();

  const trackUx = useTrackUx();

  useEffect(() => {
    trackUx(EVENT_ACTIONS.BANNER_VIEWED, TRACK_ACTION_TYPES.VIEW, {
      banner_version: BANNER_VERSION.ADDRESS_CONFIRMED,
    });
  }, [trackUx]);

  return (
    <Alert
      variant="success"
      title={toI18n(`${I18N_PATH}.address_alerts.confirmed.title`)}
    >
      <div>{values.address_suggestion.line1}</div>
      <div>
        {/* eslint-disable-next-line max-len */}
        {`${values.address_suggestion.city}, ${values.address_suggestion.state} ${values.address_suggestion.postal_code}`}
      </div>
    </Alert>
  );
};

export default AddressConfirmAlert;
